import { EditOutlined } from '@ant-design/icons';
import { Space, Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { groupInactiveRoutes } from './menuActivity';

function isMenuItem(route) {
  return (route.path && route.label) || route.type === 'divider';
}

function mapRouteToMenuItem({ route }) {
  if (route.type) return route;

  const key = route.key || route.path;

  let children = groupInactiveRoutes(route.children?.filter(isMenuItem), key, route.activeEmptyLabel);

  if (!children?.length && route.emptyLabel) {
    children = [{ key: `${route.path}/empty`, label: route.emptyLabel, disabled: true, link: false }];
  }

  let { tag, label } = route;

  if (route.new && !tag) {
    tag = { color: 'success', label: 'New' };
  }

  if (tag) {
    label = (
      <Space>
        {label}
        {tag && <Tag color={tag.color}>{tag.label}</Tag>}
      </Space>
    );
  }

  return {
    key,
    label: route.link !== false ? <Link to={route.path}>{label}</Link> : label,
    children: children?.length ? children.map(r => mapRouteToMenuItem({ route: r })) : null,
    icon: route.icon,
    disabled: route.disabled,
    title: label,
  };
}

export function routesToMenuItems({ routes }) {
  return routes.filter(isMenuItem).map(route => mapRouteToMenuItem({ route }));
}

export function generateRoutes(routes) {
  const mapRoute = (route) => {
    const childRoutes = [];

    if (route.children) {
      childRoutes.push(...route.children);
    }

    if (route.dynamicItems?.length) {
      if (childRoutes.length) {
        childRoutes.push({ type: 'divider' });
      }
      childRoutes.push(...route.dynamicItems);
    }

    if (route.manage) {
      if (childRoutes.length) {
        childRoutes.push({ type: 'divider' });
      }
      childRoutes.push({ ...route.manage, icon: <EditOutlined /> });
    }

    return {
      ...route,
      children: childRoutes.length ? childRoutes.map(mapRoute) : null,
    };
  };

  return routes?.map(mapRoute);
}
